import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ButtonAppBar from '../components/ButtonAppBar';
import DashboardCardCreditsRemaining from '../components/DashboardCardCreditsRemaining';
import DashboardImagesAnalyzed from '../components/DashboardImagesAnalyzed';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import firebase from 'firebase'
import { logout } from '../helpers/auth';

const appTokenKey = "appToken";

class Dashboard extends Component {

  state = {
    userInfo: []
  }

  componentDidMount() {
    this.getUserProfile()
  }

  getUserProfile = () => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        firebase.firestore().collection('user_profiles').where('userId', '==', user.uid).onSnapshot(snapshot => {
            let userInfo = [];
            snapshot.forEach(doc => {
              var newItem = doc.data();
              newItem.id = doc.id;
              userInfo.push(newItem);
            });

            console.log('userInfo', userInfo);

            this.setState({ userInfo: userInfo });
        })

        
    }

    })
  }

  routeChange = (route) => {
    this.props.history.push(route);
  }

  handleLogout = () => {
    logout()
    .then(() => {
        localStorage.removeItem(appTokenKey);
        this.props.history.push("/login");
        console.log("user signed out from firebase");            
    });
}

  render() {
    return (
      <div >

        <AppBar position="static">
          <Toolbar style={{flexDirection: 'row', justifyContent: 'space-between'}}>
            {/*<IconButton className={classes.menuButton} color="inherit" aria-label="Menu">
              <MenuIcon />
            </IconButton>*/}
            <Typography onClick={() => this.routeChange('/dashboard')} variant="h6" color="inherit" >
              Where's My Art?
            </Typography>
  
        
            <Button onClick={this.handleLogout} color="inherit">Logout</Button>
          </Toolbar>
        </AppBar>


        <div style={{margin: '30px auto', maxWidth: 700, display: 'flex', justifyContent: 'space-around'}}> 
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <DashboardImagesAnalyzed imageCount={this.state.userInfo[0]} route={this.routeChange}/>
            <Button onClick={() => this.routeChange('/processImage')} variant="contained">
              Analyze Images
            </Button>
          </div>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
              <DashboardCardCreditsRemaining credits={this.state.userInfo[0]} route={this.routeChange}/>
              <Button onClick={() => this.routeChange('/pricing')} variant="contained">
                Buy Credits
              </Button>
            </div>
          </div>

    
        <br/>
        {/*<Container className="bottom-nav">
        <Row className="show-grid">
          <Col xs={4} className="col-bottom">
              <Link to="/myLists"><i className="bottom-icon material-icons">collections</i></Link>
          </Col>
          <Col xs={4} className="col-bottom">
            <label>
              <i className="bottom-icon material-icons">camera_alt</i> 
            </label>
          </Col>
          <Col onClick={this.handleLogout} xs={4} className="col-bottom">
            <i className="bottom-icon material-icons">assignment_return</i>
          </Col>
        </Row>
    </Container>*/}
      </div>
    );  
  }
}

export default Dashboard;
